module.exports = __webpack_public_path__ + "static/media/08.3f23a0ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Infographics/slides/08.jpg
// module id = 983
// module chunks = 0